import { defineStore } from "pinia";
import type { Cliente } from "@/types";
import { indexArray, isNilOrEmpty, isUndefined, notif } from "@/utils";
import { useSettingsStore } from "@/stores/settings";
import type { RemovableRef } from "@vueuse/shared";
import { useLocalStorage } from "@vueuse/core";
import { useOrdiniStore } from "@/stores/ordini";
import { useArticoliStore } from "@/stores/articoli";

export type CustomerStore = {
  CUSTOMERS: { [key: string]: Cliente };
  RISULTATI_RICERCA_CLIENTE: Cliente[];
  CUSTOMER_SEARCH_FILTER?: string;
  VECCDCLF: RemovableRef<string>;
  VECCDDES: RemovableRef<string>;
  FIDO: number | undefined;
};
const ls = useLocalStorage;
export const useCustomerStore = defineStore("customerStore", {
  state: (): CustomerStore => ({
    CUSTOMERS: {},
    RISULTATI_RICERCA_CLIENTE: [],
    CUSTOMER_SEARCH_FILTER: undefined,
    VECCDCLF: ls<string>("isales/customerStore/VECCDCLF", ""),
    VECCDDES: ls<string>("isales/customerStore/VECCDDES", ""),
    FIDO: undefined,
  }),
  getters: {
    CUSTOMERS_getAll(state): Cliente[] {
      return Object.values(state.CUSTOMERS);
    },
    CUSTOMERS_get(state): (veccdclf: string, veccddes: string) => Cliente {
      return (veccdclf: string, veccddes: string): Cliente => {
        const key = `${veccdclf}-${veccddes}`;
        return state.CUSTOMERS[key];
      };
    },
    CUSTOMER_SEARCH_FILTER_get(state): string | undefined {
      return state.CUSTOMER_SEARCH_FILTER;
    },
    CUSTOMERS_getCurrent(state): Cliente | undefined {
      if (this.CUSTOMERS_selected) {
        return this.CUSTOMERS_get(state.VECCDCLF as string, state.VECCDDES as string);
      }
    },
    CUSTOMERS_selected(state): boolean {
      return !isNilOrEmpty(state.VECCDCLF) && !isUndefined(state.VECCDDES);
    },
    FIDO_defined(state): (idDoc: string) => boolean | undefined {
      return (idDoc: string) => {
        if (!isUndefined(state.FIDO)) {
          const settingsStore = useSettingsStore();
          return settingsStore.ControlloFido_get(idDoc);
        }
        return false
      };
    },
  },
  actions: {
    CUSTOMER_set(cliente: Cliente) {
      this.CUSTOMER_unset();
      this.VECCDCLF = cliente.veccdclf;
      this.VECCDDES = cliente.veccddes;
    },
    CUSTOMER_unset() {
      const ordiniStore= useOrdiniStore();
      ordiniStore.ORDINE_cleanAll();
      ordiniStore.RIEPILOGO_unset();

      const articoliStore = useArticoliStore();
      articoliStore.ARTICOLI_unsetAll();

      this.VECCDCLF = "";
      this.VECCDDES = "";
    },
    CUSTOMERS_setAll(clienti: Cliente[]): void {
      clienti.map((cliente: Cliente) => {
        cliente.indirizzo = `${cliente.vecdsind ?? ""} ${cliente.veccdcap ?? ""} ${cliente.vecdsloc ?? ""} (${cliente.veccdpro ?? ""})`;
        if (cliente.DESvecdsind) {
          cliente.indirizzoDestinazione = `${cliente.DESvecdsind ?? ""} ${cliente.DESveccdcap ?? ""} ${cliente.DESvecdsloc ?? ""} (${cliente.DESveccdpro ?? ""})`;
        } else {
          cliente.indirizzoDestinazione = undefined;
        }
        cliente.key = `${cliente.veccdclf}-${cliente.veccddes}`;
      });
      //this.CUSTOMERS = indexArray(clienti, (cliente)=>`${cliente.veccdclf}-${cliente.veccddes}`);
      this.CUSTOMERS = indexArray(clienti, "key");
    },
    CUSTOMERS_unset() {
      this.CUSTOMERS = {};
    },
    CUSTOMER_SEARCH_FILTER_set(value?: string) {
      this.CUSTOMER_SEARCH_FILTER = value;
    },
    async CUSTOMERS_loads(): Promise<void> {
      const settingsStore = useSettingsStore();
      const wsClient = settingsStore.wsClient;
      const response = await wsClient.GetClienti();
      if (response?.Success) {
        this.CUSTOMERS_setAll(response.Data);
      } else {
        notif("Errore", response?.Message, "error");
      }
    },
    async FIDO_update() {
      const settingsStore = useSettingsStore();
      const wsClient = settingsStore.wsClient;
      const response = await wsClient.GetFidoCliente({
        sVeccdclf: this.VECCDCLF,
      });
      if (response?.Success) {
        this.FIDO = response.Data;
      } else {
        notif("Errore", response?.Message, "error");
      }
    },

  },
});
